import React from "react";
import { useHistory } from "react-router-dom";
import { Api } from "../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
//import ReactToPrint from "react-to-print";
import AvalCE from "../components/content/casos_especiales/aval.js";
class LicensePrint extends React.Component {
  constructor(props) {
    super(props);

    this.handleCloseModalCE = this.handleCloseModalCE.bind(this);
    this.handleClick_ce = this.handleClick_ce.bind(this);
    this.toggleCollapse = this.toggleCollapse.bind(this);
    this.setCasosEspecialesPage = this.setCasosEspecialesPage.bind(this);

    this.state = {
      modalLicencia: false,
      working: true,

      nivelUsuario: localStorage.nivel_actual,

      casos_especiales: [],
      caso_especial: {
        id: "",
        tipo_importacion_nombre: "",
        tipo_producto_importacion: "",
        listado: [],
        nombre_solicitante: "",
        fabricante_razon_social: "",
        hora: "",
        importador_razon_social: "",
        pais_procedencia_nombre: "",
        pais_origen_nombre: "",
        guia_area: "",
        no_factura: "",
        autorizador_por: "",
        folio: "",
        fines_texto: "",
        importacion_texto: "",
        estimado: "",
        fecha_aprueba: "",
        qr: "",
      },
      toggle: false,
      paginaActual_ce: 0,
      modalCasoEspecial: false,
      cat_tipo_importacion: Api.loadCatalogue("cat_tipo_importacion"),
      paginas_ce: 0,
      previa: false,
      previa_rul: "",
      activeTab: "1",
      collapse: [
        { id: 1, collapse: true },
        { id: 2, collapse: false },
        { id: 3, collapse: false },
        { id: 4, collapse: false },
      ],

      registros_ce: 0,
    };
    this.toggleCollapse = this.toggleCollapse.bind(this);

    if (props.auth.user.name === undefined) {
      this.props.history.push("login");
    }
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  toggleCollapse(index) {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({
      collapse: newArray,
    });
  }

  componentDidMount() {
    // si el usuario no es nivel disaan redireccionamos a home
    if (this.state.nivelUsuario !== "8") {
      window.location.href = "/";
    }

    this.setCasosEspecialesPage(1);

    /******* BUSCADORES *********/
    /** BUSCADOR PARA CASOS ESPECIALES */
    let buscadorCE = {
      target: "#buscadorCE",
      nombre: "buscadorCE",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 4,
            name: "folio",
            type: "text",
            label: "Folio",
            placeHolder: "Ingrse folio",
          },
        },
        {
          select: {
            cols: 4,
            name: "tipo_importacion",
            type: "text",
            label: "Tipo importación",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.cat_tipo_importacion
                .filter((item) => !["1", "7", "8"].includes(item.id))
                .forEach((ti) => {
                  me.innerHTML += `<option value="${ti.id}">${ti.descripcion}</option>`;
                });
            },
          },
        },
        {
          input: {
            cols: 4,
            name: "fecha_emision",
            type: "date",
            label: "Fecha emisión",
          },
        },

        {
          input: {
            cols: 5,
            name: "establecimiento_importador",
            type: "text",
            label: "Establecimiento importador",
            placeHolder: "Ingrese establecimiento importador",
          },
        },

        {
          input: {
            cols: 5,
            name: "establecimiento_fabricante",
            type: "text",
            label: "Establecimiento fabricante",
            placeHolder: "Ingrese establecimiento fabricante",
          },
        },
        {
          button: {
            cols: 2,
            name: "buscamov",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscarCasoEspecial: buscadorCE.data() });
              this.setCasosEspecialesPage(1);
            },
          },
        },
      ],
    };

    buscadorCE = Api.form(buscadorCE);
    /** TERMINA BUSCADOR PARA CASOS ESPECIALES */
  }

  setCasosEspecialesPage(page) {
    this.setState({ workingGridCE: true });

    let search = this.state.buscarCasoEspecial;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getCasosEspecialesDISAANImprimir?page=" + page + src).then(
      (ce) => {
        this.setState({
          casos_especiales: ce.data,
          paginas_ce: ce.last_page,
          registros_ce: ce.total,
          paginaActual_ce: ce.current_page,
          workingGridCE: false,
        });
      }
    );
  }

  handleCloseModalCE() {
    this.setState({
      modalCasoEspecial: false,
      caso_especial: {
        id: "",
        tipo_importacion_nombre: "",
        tipo_producto_importacion: "",
        listado: [],
        nombre_solicitante: "",
        fabricante_razon_social: "",
        importador_razon_social: "",
        pais_procedencia_nombre: "",
        pais_origen_nombre: "",
        guia_area: "",
        no_factura: "",
        autorizador_por: "",
        folio: "",
        fines_texto: "",
        importacion_texto: "",
        estimado: "",
        fecha_aprueba: "",
        hora: "",
        qr: "",
      },
    });
  }

  handleClick_ce(e) {
    this.setState({
      modalCasoEspecial: true,
      working: true,
    });
    Api.fetch("app/getCasoEspecial/?id=" + e.target.id).then((ce) => {
      this.setState({
        caso_especial: ce,
        working: false,
      });
    });
  }

  render() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "1",
                })}
                onClick={() => {
                  this.toggleTab("7");
                }}
              >
                <span className="d-sm-none">
                  CASOS ESPECIALES
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_ce}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  CASOS ESPECIALES
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_ce}
                  </span>
                </span>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
              <fieldset>
                <div id="buscadorCE"></div>
              </fieldset>
              <div className="table-responsive">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Tipo importación</th>
                      <th className="text-center">
                        Establecimiento importador
                      </th>
                      <th className="text-center">
                        Establecimiento fabricante
                      </th>
                      <th className="text-center">Fecha emisión</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGridCE ? "hide" : ""}>
                    {this.state.casos_especiales.length > 0 ? (
                      this.state.casos_especiales.map((ce, index) => (
                        <tr key={index}>
                          <td title={ce.folio} className="text-center">
                            {ce.folio}
                          </td>
                          <td className="text-center">
                            {ce.tipo_importacion_nombre}
                          </td>
                          <td className="text-center">
                            {ce.importador_razon_social}
                          </td>
                          {/*            <td className="text-center">{lic.tramite}</td> */}
                          <td className="text-center">
                            {ce.fabricante_razon_social}
                          </td>
                          {<td className="text-center">{ce.fecha_emision}</td>}

                          <td className="text-center">
                            <button
                              title="Imprimir"
                              onClick={this.handleClick_ce}
                              id={ce.id}
                              className="btn btn-info"
                              width="60"
                            >
                              <i
                                title="Imprimir"
                                className="fa fa-print"
                                id={ce.id}
                              ></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No hay datos
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGridCE ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setCasosEspecialesPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_ce - 1 > 0) {
                            this.setCasosEspecialesPage(
                              this.state.paginaActual_ce - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_ce} de{" "}
                          {this.state.paginas_ce}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_ce >=
                            this.state.paginaActual_ce + 1
                          ) {
                            this.setCasosEspecialesPage(
                              this.state.paginaActual_ce + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setCasosEspecialesPage(this.state.paginas_ce);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Ver Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.setCasosEspecialesPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_ce}
                      value={this.state.paginaActual_ce}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
          </TabContent>

          <div className={this.state.previa ? "previa" : "hide"}>
            <iframe
                title="Vista previa"
                className="rounded"
                src={this.state.previa_url}
                loading="eager"
            ></iframe>
            <center>
              <div className="btn-group">
                <button
                  onClick={() => {
                    this.setState({ previa: false });
                  }}
                  className="btn btn-danger"
                >
                  Regresar
                </button>
                <a
                  className="btn btn-primary"
                  href={this.state.previa_url + "&download=1"}
                  download="download"
                >
                  Descargar
                </a>
              </div>
            </center>
          </div>
        </div>

        <AvalCE
          modalCasoEspecial={this.state.modalCasoEspecial}
          change={this.handleCloseModalCE}
          caso_especial={this.state.caso_especial}
          working={this.state.working}
        ></AvalCE>
      </div>
    );
  }
}

const App = (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <LicensePrint auth={auth} history={history} {...props} />;
};

export default App;
